<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div class="vif_ip_addrs">
    <v-data-table
    :headers="headers"
    :items="addrs"
    :search="search"
    sort-by="vif_id"
    class="elevation-1"
    @dblclick:row="on_dbl_click"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title><h2 class="br">IPv4 addresses</h2></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <div>
            <vif_box v-model="show_vif_form" @canceled="on_vif_canceled" 
                @selected="on_vif_select($event)">
            </vif_box>
          </div>

          <template v-slot:activator="{ props }">
            <v-btn @click="new_item(item)"
              color="primary" dark class="mb-2"
              v-bind="props"
            >
              Add IPv4 address
            </v-btn>
          </template>
          <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
            <v-card-title>
              <span class="headline">{{ form_title }}</span>
            </v-card-title>

            <v-card-text>
              <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        v-if="edited_index != -1"
                        v-bind:readonly="true"
                        v-model="edited_item.vif_id"
                        label="VIF ID"
                    ></v-text-field>

                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.vif_name"
                        label="VIF Name"
                      >
                      <template v-if="edited_index == -1" #append>
                          <v-btn @click="open_vif_form()">...</v-btn>
                      </template>                          
                      </v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <v-text-field
                        v-if="edited_index != -1"
                        v-bind:readonly="true"
                        v-model="edited_item.port"
                        label="Port"
                    ></v-text-field>

                    <v-text-field
                        v-if="edited_index != -1"
                        v-bind:readonly="true"
                        v-model="edited_item.encapsulation"
                        label="Encapsulation"
                    ></v-text-field>                  

                    <v-text-field
                        v-if="edited_index != -1"
                        v-bind:readonly="true"
                        v-model="edited_item.svid"
                        label="SVID. Service VLAN Id (Outer VLAN Id)"
                    ></v-text-field>                  

                    <v-text-field
                        v-if="edited_index != -1"
                        v-bind:readonly="true"
                        v-model="edited_item.cvid"
                        label="CVID. Client VLAN Id (Inner VLAN Id)."
                    ></v-text-field>

                    <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.ip"
                        label="IPv4 address"
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider rules="required|ipv4_mask" v-slot="{ errors }">
                      <v-text-field
                        v-bind:readonly="edited_index != -1"
                        v-model="edited_item.mask"
                        label="IPv4 mask"
                      ></v-text-field>
                      <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <v-text-field
                        v-if="edited_index != -1"
                        v-bind:readonly="true"
                        v-model="edited_item.type"
                        label="Address type"
                    ></v-text-field>                    
                </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn v-if="edited_index === -1" color="blue darken-1" :disabled="invalid" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-form></v-card></ValidationObserver>
        </v-dialog>
      </v-toolbar>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="me-2"
        @click="edit_item(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="delete_item(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
    </template>
    </v-data-table>
</div>
</template>
  
<script>
  import api_client from '../services/api.js';
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { ValidationProvider, extend } from 'vee-validate';
  import { ValidationObserver } from 'vee-validate';
  import { required, numeric } from 'vee-validate/dist/rules';
  import vif_box from "../components/vif_box.vue";
  import "../validation_rules.js"

  export default {
    name: "vif_ip_addr",
    components: { Treeselect, ValidationProvider, ValidationObserver, vif_box },
    data: () => ({
        show_vif_form: false,
        search: '',
        dialog: false,
        headers: [
            { text: 'VIF Id', value: 'vif_id', align: 'start' },
            { text: 'VIF Name', value: 'vif_name' },
            { text: 'Port', value: 'port' },
            { text: 'SVID', value: 'svid' },
            { text: 'CVID', value: 'cvid' },
            { text: 'Encapsulation', value: 'encapsulation' },
            { text: 'IPv4 address', value: 'ip' },
            { text: 'IPv4 mask', value: 'mask' },
            { text: 'Address type', value: 'type' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        addrs: [],
        edited_index: -1,
        edited_item: {
        },
        default_item: {
            vif_id: 0,
            vif_name: '',
            port: '',
            svid: '',
            cvid: '',
            encapsulation: '',
            ip: '',
            mask: 0,
            type: '',
        },
    }),

    computed: {
        form_title() {
            return this.edited_index === -1 ? 'Add IPv4 address' : 'IPv4 address'
        },
    },

    watch: {
    },

    created() {
      this.initialize()
    },

    methods: {
        on_vif_canceled() {
          this.show_vif_form = false;
        },

        on_vif_select(data) {
          this.edited_item.vif_name = data.name;
          this.show_vif_form = false;
        },

        open_vif_form() {
          this.show_vif_form = !this.show_vif_form;
        },

        initialize() {
          this.show_vif_form = false;
          api_client.sh_vif_ip_addrs()
          .then(response => {
              this.addrs = response.data
          })
          .catch(error => {
              console.log(error)
          })
        },

        edit_item(item) {
          this.edited_index = this.addrs.indexOf(item);
          this.edited_item = Object.assign({}, item);
          this.dialog = true;
        },

        new_item() {
          requestAnimationFrame(() => {
            this.$refs.observer.reset();
          });          
          this.edited_index = -1;
          this.edited_item = Object.assign({}, this.default_item);
          this.dialog = true;
        },

        on_dbl_click(event, data) {
          this.edit_item(data.item);
        },

        close() {
          this.dialog = false;
          this.$nextTick(() => {
              this.editedIndex = -1
          });
        },

        delete_item(item) {
          this.edited_index = this.addrs.indexOf(item);
          this.edited_item = Object.assign({}, item);
          this.$confirm("Are you sure you want to delete IPv4 address " + 
                item.ip + "/" + item.mask + " from VIF '" + item.vif_name + "' ?")
          .then(() => {
            this.delete_item_confirm()
          });
        },

        delete_item_confirm() {
          api_client.del_vif_ip_addr({
            vif_name: this.edited_item.vif_name,
            ip: this.edited_item.ip,
            mask: this.edited_item.mask,
          })
          .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
              this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
              return;
            }
          })
          .catch(error => {
              console.log(error);
              this.$fire({title: "Command failed", text: error, type: "warning"});
          })
          this.addrs.splice(this.edited_index, 1);
        },

        save() {
          let new_ip_addr = {
            vif_name: this.edited_item.vif_name,
            ip: this.edited_item.ip,
            mask: this.edited_item.mask,
          };

          api_client.add_vif_ip_addr(new_ip_addr)
            .then(response => {
              if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
              }

              api_client.sh_vif_ip_addr(new_ip_addr)
                .then(response => {
                  if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    return;
                  }

                  this.addrs.push({
                    vif_id: response.data.vif_id,
                    vif_name: response.data.vif_name,
                    port: response.data.port,
                    svid: response.data.svid,
                    cvid: response.data.cvid,
                    encapsulation: response.data.encapsulation,
                    ip: response.data.ip,
                    mask: response.data.mask,
                    type: response.data.type,
                  })
                })
                .catch(error => {
                  console.log(error);
                  this.$fire({title: "Command failed", text: error, type: "warning"});
                });            
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
          this.close();
        },
    }
  };
  </script>
  